import styled from 'styled-components';
import { device } from '../../Config/device';

import Input from '../../Components/Form/Input';
import PageText from '../../Components/Text/PageText';
import TextArea from '../../Components/Form/TextArea';

export const BadgeSpan = styled.div`
    display: inline-block;
    padding: 0.2rem 0.6rem;
    border-radius: 12px;
    font-size: 0.7rem;
    font-weight: 600;
    text-transform: uppercase;
    width: fit-content;

    ${props => props.Type === 'RECURRING' &&
        `
            background: linear-gradient(135deg, #cfe2ff 0%, #b3d9ff 100%);
            color: #084298;
        `
    }
    ${props => props.Type === 'ONE_TIME' &&
        `
            background: linear-gradient(135deg, #fff3cd 0%, #ffe69c 100%);
            color: #856404;
        `
    }
`;

export const MessagesColumn_Actions = styled.div`
    display: flex;
    justify-content: flex-end;
`;

export const MessagesColumn_Message = styled.div`
    padding-right: 1rem;
`;

export const MessagesColumn_Recipients = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
`;

export const MessagesColumn_Recurrence = styled.div`
    display: flex;
    align-items: center;
`;

export const MessagesColumn_Scheduled = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
`;

export const MessagesContainer = styled.div`
    width: 100%;
    background: white;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    overflow: hidden;
`;

export const MessagesTable = styled.div`
    width: 100%;
`;

export const MessagesTableBody = styled.div`
    display: flex;
    flex-direction: column;
`;

export const MessagesTableRow = styled.div`
    display: grid;
    grid-template-columns: 1.5fr 2.5fr 1.2fr 1.5fr 0.8fr;
    gap: 1rem;
    padding: 1.25rem 1.5rem;
    border-bottom: 1px solid #e2e8f0;
    transition: all 0.2s;
    cursor: pointer;
    align-items: center;
`;

export const MessagesTableHeader = styled.div`
    display: grid;
    grid-template-columns: 1.5fr 2.5fr 1.2fr 1.5fr 0.8fr;
    gap: 1rem;
    padding: 1rem 1.5rem;
    background: linear-gradient(135deg, #188ae8 0%, #0A2B49 100%);
    color: white;
    font-weight: 600;
    font-size: 0.85rem;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    align-items: center;
`;

export const PseudoCheckbox = styled.div`
    ${
        props => props.Selected && `background-color: #${props.BackgroundColor};`
    }

    border: 2px solid #274775;
    border-radius: 5px;
    height: 25px;
    min-width: 25px;
    width: 25px;

    @media(hover:hover) {
        :hover {
            ${props => `background-color: #${props.BackgroundColor};`}
            cursor: pointer;
        }
    }
`;

export const RadioButtonPageText = styled(PageText)`
    @media(hover:hover) {
        :hover {
            ${props => !props.ReadOnly ? `cursor: pointer;` : `cursor: not-allowed;`}
        }
    }
`;

export const RadioButtonParentContainer = styled.div`
    align-items: center;
    display: flex;
    justify-content: flex-start;
    margin-top: 5px;

    > div:first-child {
        margin-right: 5px;
    }
`;

export const RecurrenceLogicContainer = styled.div`
    background: var(--white-concrete);
    border: 2px solid var(--white-concrete-light);
    border-radius: 10px;
    padding: 10px 15px;
`;

export const StartDateContainer = styled.div`
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    border: 1px solid #dee2e6 !important;
    border-radius: 0.25rem !important;
    padding: 1rem !important;
`;

export const StyledMessageTextArea = styled(TextArea)`
    margin-bottom: 0px;
    width: 100%;

    > textarea {
        background-color: var(--white-concrete);
        border: none;
        padding: 5px;
        resize: none;
    }
`;

export const TextInput = styled(Input)`
    margin-right: 10px;

    @media ${device.maxwidth.mobile} {
        width: 170px;
    }

    @media ${device.minwidth.mobile} {
        width: 260px;
    }

    @media ${device.minwidth.ipad} {
        width: 320px;
    }

    > input {
        border-radius: 10px;
    }
`;